import { RootState } from "../root/redux.types";

export const selectApptUserPreference = (state: RootState) =>
  state.apptUserPreference;
